import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLanguagesService } from '../../../../services/languages/api/api-languages.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-language-edit-modal',
  templateUrl: './language-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LanguageEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  languageId: number = 0;
  languageIso: string = '';

  private callbackSaved?: () => void;

  constructor(private apiLanguagesService: ApiLanguagesService, private alertsService: AlertsService) {}

  show(languageId: number, languageIso: string, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.languageId = languageId;
    this.languageIso = languageIso;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLanguagesService.editLanguage(this.languageId, this.languageIso).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Language updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating language : ' + error);
      }
    );
  }
}
